import { render, staticRenderFns } from "./Comp19t3.vue?vue&type=template&id=08c88153&scoped=true&"
import script from "./Comp19t3.vue?vue&type=script&lang=js&"
export * from "./Comp19t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp19t3.vue?vue&type=style&index=0&id=08c88153&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c88153",
  null
  
)

export default component.exports